import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Event from '../../../components/betslip/Event';

import {
  triggerUpdateRightSidebar,
} from '../../../modules/rightSidebar/actions';

import { getInRunningFlagForEventId } from '@xanadu/ui-shared/modules/event/selectors';

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateRightSidebar: triggerUpdateRightSidebar,
  }, dispatch);
}

function mapStateToProps(state, ownProps) {
  const { eventId } = ownProps;
  const eventInRunning = getInRunningFlagForEventId(state, eventId);

  return {
    widthSize: state.getIn(['application', 'widthSize'], ''),
    eventInRunning
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Event);
